
import { Box, Button, Text, Flex, Popover, PopoverContent, PopoverTrigger, useDisclosure, PopoverBody, Drawer, DrawerOverlay, Alert, AlertIcon } from '@chakra-ui/react'
import MyDiv from './payroll.style'
import { PayrollList, PayrollSummaryCard } from './components'
import { useState } from 'react';
import { CalendarIcon } from '@chakra-ui/icons';
import Calendar from 'react-calendar';

const sortOptions = ['Sort by Employee Name A-Z', 'Sort by Employee Name Z-A', 'Sort by Net Pay High to Low', 'Sort by Net Pay Low to High', 'Sort by Gross Salary Low to High', 'Sort by Gross Salary High to Low', 'Sort by Effective Work Days Low to High', 'Sort by Effective Work Days High to Low'];

const Payroll = () => {
  const [selectedRows, setSelectedRows] = useState<number[]>([]);
  const [selected, setSelected] = useState<string>(sortOptions[0]);
  
  const [payrollSumarryOpen, setPayrollSumarryOpen] = useState(false);
  const [alert, setAlert] = useState(false);

  return (
    <MyDiv>
      <Box  >
        <Flex className="page_heading flex_header">
          <Text className="font-poppins text_3xl text_semibold font_dark">Payroll</Text>
          {/* <Popover isOpen={isCalendarOpen} onOpen={openCalendar} onClose={closeCalendar} placement="bottom-end">
            <PopoverTrigger>
              <Button leftIcon={<CalendarIcon />} padding={3} variant="outline" >
                <Text className="font-poppins text_sm text_regular">{formatMonthYear(selectedDate)}</Text>
              </Button>
            </PopoverTrigger>
            <PopoverContent w="auto">
              <PopoverBody p={2} display="flex" justifyContent="center">
                <Calendar
                  value={selectedDate}
                  onChange={(value) => {
                    if (value instanceof Date) {
                      setSelectedDate(value);
                      onClose();
                    }
                  }}
                  view="year"
                  maxDetail="year"
                  maxDate={new Date()}
                />
              </PopoverBody>
            </PopoverContent>
          </Popover> */}
        </Flex>

        {alert && <Box mb={8} >
          <Alert status='warning' borderRadius={'60px'}>
            <AlertIcon />
            <Box className='font-poppins text_medium text_lg'>
              Payroll has been approved by the Branch Head. You may now proceed to salary disbursement.
            </Box>
          </Alert>

        </Box>}


        <PayrollList sortOptions={sortOptions} selectedRows={selectedRows} setSelectedRows={setSelectedRows} selected={selected} setSelected={setSelected} />

        {/* <Box position="fixed" bottom="30px" right="30px" zIndex="1000">
          {selectedRows.length > 0 && (
            <Button bg={'#006838'} size="md" borderRadius="full" px={6} onClick={Toogle} color="white"
              _hover={{ bg: '#006838' }}>
              View Payroll Summary
            </Button>
          )}
        </Box> */}
        {payrollSumarryOpen && (
          <Drawer size="md" placement='right' isOpen={payrollSumarryOpen} onClose={() => setPayrollSumarryOpen(false)}>
            <DrawerOverlay />
            <PayrollSummaryCard onClose={() => setPayrollSumarryOpen(false)} setAlert={setAlert} />
          </Drawer>
        )}
      </Box>
    </MyDiv>
  )
}

export default Payroll;